import { EventEmitter, Injectable } from '@angular/core';
import { ConfigurationService } from './configuration.service';
import * as signalR from "@aspnet/signalr";
import { HubConnectionBuilder } from '@aspnet/signalr';
import { IDtoNotification } from '../models/dto-notification.model';
import { IResult } from '../models/result.model';
import { DataService } from './data.service';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
@Injectable()
export class SignalRService {

  public messageReceived = new EventEmitter<IDtoNotification[]>();
  public connectionEstablished = new EventEmitter<boolean>();
  private connectionIsEstablished = false;
  private identityUrl = '';
  private hubConnection: signalR.HubConnection
  constructor(private configurationService: ConfigurationService
    , private service: DataService) {
    if (this.configurationService.isReady) {
      this.identityUrl = this.configurationService.serverSettings.identityUrl;
      this.start();
    } else {
      this.configurationService.settingsLoaded$.subscribe(x => {
        this.identityUrl = this.configurationService.serverSettings.identityUrl;
        this.start();
      });
    }
  }
  private start(): void {
    this.createConnection();
    this.registerOnServerEvents();
    this.startConnection();
  }
  private createConnection() {
    this.hubConnection = new HubConnectionBuilder()
      .withUrl(`${this.identityUrl}notifications`)
      .build();
  }
  private startConnection(): void {
    this.hubConnection
      .start()
      .then(() => {
        this.connectionIsEstablished = true;
        //console.log('Hub connection started');
        this.connectionEstablished.emit(true);
      })
      .catch(err => {
        //console.log('Error while establishing connection, retrying...');
        setTimeout(function () { this.startConnection(); }, 5000);
      });
  }
  private registerOnServerEvents(): void {
    this.hubConnection.on('addNotifications', (data: any) => {
      this.messageReceived.emit(data);
    });
  }
  public updateNotification(dto: IDtoNotification): Observable<IResult> {
    const url = `${this.identityUrl}api/Notifications/updateNotification`;
    return this.service.putWithId(url, dto).pipe(map((response: any) => {
      return response;
    }));
  }
  public getNotificationsByUserId(userId: string): Observable<IDtoNotification[]> {
    const url = `${this.identityUrl}api/Notifications/getNotificationsByUserId?userId=${userId}`;
    return this.service.get(url)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  // public startConnection = () => {
  //   let options = {};
  //   options["headers"] = new HttpHeaders()
  //       .append('authorization', 'Bearer ' + this.securityService.GetToken());

  //   this.hubConnection = new signalR.HubConnectionBuilder()
  //     .withUrl(`${this.identityUrl}notifications`, options)//{ accessTokenFactory: () => 'Bearer ' + this.securityService.GetToken()}
  //     .build();
  //   this.hubConnection
  //     .start()
  //     .then(() => console.log('Connection started'))
  //     .catch(err => console.log('Error while starting connection: ' + err))
  // }
  // public getNotificationListener = () => {
  //   this.hubConnection.on('addNotification', (data) => {
  //     console.log(data);
  //   });
  // }
}